export default {
  act_not_start_yet: 'Lucky draw not start yet',
  act_end: 'End of lucky draw',
  lottery_chance_note: 'Number of draws left: {0}',
  base_comp_rule: "T&C's",
  base_comp_awards: 'My rewards',
  act_risk_error: 'You are not eligible to join this time.',
  act_risk_error_tip: "Please refer to the T&C's for more information",
  act_access_error: 'Sorry, you are not eligible to join this time.',
  act_access_error_tip: "Please refer to the T&C's for more information",
  use_out_of_chance: 'you have no more chance',
  draw_req_timeout:
    'Request time out. Prize will be allocated to "My Rewards" automatically if you successfully win it.',
  award_not_available: 'Sorry, prize is not available at this moment',
  wind_modal: {
    congratulation: 'Congratulations!',
    name: 'You’ve won {name}',
    note: 'Please find your prize in "My Rewards"',
    redeem_now: 'Redeem Now'
  },
  no_prize_model: {
    title: 'Better luck next time!',
    try_again: 'Try Again'
  },
  task_panel: {
    show_all: 'Show all',
    hide: 'Hide',
    do_task: 'Complete Now',
    try_tomorrow: 'Try tomorrow',
    completed: 'Completed',
    earn: 'Complete to earn ',
    chance: 'draw | draws',
    not_ready: 'Not started',
    expired: 'Expired',
    signin_success: 'success'
  },
  my_awards: {
    valid_date: 'Valid date',
    date_format: 'yyyy/MM/dd',
    use_coupon: 'Book Now',
    no_awards: 'Stay tuned for more rewards!',
    no_more: ''
  },
  page_my_awards: 'My rewards',
  page_account_error: 'Not Valid',
  page_access_error: 'No Access',
  page_rule: 'Terms and conditions',
  track: {
    base_comp_rule: 'terms_conditions',
    base_comp_awards: 'my_rewards',
    base_comp_broadcast: 'bullet_screen',
    base_comp_primary_btn: 'key_button',
    base_comp_footer_btn: 'bottom_line_button',
    base_comp_float_btn: 'assistive_button',
    base_comp_img: 'image',
    base_comp_advertise: 'advertisement',
    turnplate_btn: 'spin_wheel_draw',
    lucky_box_btn: 'mystery_boxes_open_{n}',
    popup_coupon: 'coupon_popup'
  }
};
